<template>
  <div class="pc-container">
    <div class="header">
      <div class="header-box">
        <div class="header-logo">
          <img src="../assets/pc/logo.png">
        </div>
        <div class="header-li-box">
          <div class="header-li">
            <span>首页</span>
            <div class="li-active"></div>
          </div>
          <div class="header-li" @click="goToWhere('/product')"><span>产品介绍</span></div>
          <div class="header-li" @click="goToWhere('/banner')"><span>下载APP</span></div>
          <div class="header-li" @click="goToWhere('/secret')"><span>隐私政策</span></div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content-banner">
        <img src="../assets/pc/map.png">
      </div>
      <div class="introduce-box">
        <div class="itd-li">
          <div class="itd-title-box">
            <div>
              <img src="../assets/pc/line_bar.png">
            </div>
            <div class="itd-t">
              <div class="itd-t-t1">CENTER PROFILE</div>
              <div class="itd-t-t2">中心简介</div>
            </div>
          </div>
          <div class="itd-c-box">
            <div class="itd-c c-bold">
              麻城市汽车客运中心位于麻城经济开发区京广大道北86号,自2018年11月20日正式启用,占地面积150亩,建筑面积15823平方米。
            </div>
            <div class="itd-c">
              2019年被湖北省道路运输管理局评定为省一级客运站。该站现开行有省际班线3条、市际班线10条、县际班线4条、城市公交线路11条、城乡公交线路70条,是集长中短途道路班线客运、城市公交、城乡公交、充电站、加油站、汽车维修等为一体的综合性客运站。
            </div>
            <div class="itd-c">
              麻城宇通公交有限公司成立于2019年07月29日，注册地位于麻城经济开发区京广大道北86号，法定代表人为范斌。
            </div>
          </div>
        </div>
        <div class="itd-li">
          <div class="itd-title-box">
            <div>
              <img src="../assets/pc/line_bar.png">
            </div>
            <div class="itd-t">
              <div class="itd-t-t1">REGIONAL ADVANTAGE</div>
              <div class="itd-t-t2">区域优势</div>
            </div>
          </div>
          <div class="itd-c-box">
            <div class="itd-c-box-d">
              <div>
                <div class="itd-c">
                  麻城市汽车客运中心区位优势明显,南与麻城火车南站相距2公里，北与麻城火车北站(高铁站)相距2.5公里,距离大广高速、沪蓉高速公路入口均不超过10公里。随着道路运输事业的不断发展和车站周边环境的不断改善,麻城市汽车客运中心已成为麻城重要的公路交通枢纽和公共服务窗口。
                </div>
                <div class="itd-c mlt25">
                  麻城市全域公交改革工作自2023年3月1日启动,先后投入1.6亿元完成对原13家农村班线客运经营主体313台燃油车辆评估和收购,通过公开招标方式新采购180台新能源纯电动公交车,全市新能源车合计235台,逐步淘汰老旧传统柴油农村客运车辆,实现城市、城乡新能源纯电动公交车运营。2024年1月,投入1000万余元建设麻城市全域公交智慧平台项目,打造“大数据治理、大平台智融、大公交运营、大社会共管、大服务惠民“的智慧公交体系,现已完成90%的工程量,正在进行线路采集和编辑、掌上公交著作权审批、APP扫码支付对接等工作。
                </div>
              </div>
              <div class="itd-sign">
                <img src="../assets/pc/sign.jpg">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-box">
        <div class="footer-li">
          <div class="fl-text">COPYRIGHT 2023-2024 湖北麻城宇通公交公司</div>
          <div>
            <div><img src="../assets/pc/national.png"><span class="fl-nationl">鄂ICP备2024067966号</span></div>
          </div>
        </div>
        <div class="footer-li">
          <img class="fl-p-img" src="../assets/pc/phone.png">
          <span class="fl-phone">0713-2950303</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToWhere(flag) {
      this.$router.push(flag);
    }
  }

}
</script>

<style lang="scss" scoped>
//如果个别地方不想转化px。可以简单的使用大写的 PX 或 Px
.pc-container {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .header {
    height: 110PX;

    .header-box {
      margin: 0 360PX;
      height: 100%;
      display: flex;

      .header-logo {
        margin: 27PX 0;
      }

      .header-li-box {
        margin-left: 250PX;
        display: flex;
        align-items: center;
        font-size: 16PX;

        .header-li {
          text-align: center;
          padding: 42PX 30PX;
          position: relative;
          cursor: pointer;
        }

        .li-active {
          border-bottom: 4PX solid #61ADBE;
          bottom: 0;
          left: 0;
          width: 100%;
          position: absolute;
        }
      }
    }
  }

  .content {
    .content-banner {
      height: 404PX;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .introduce-box {
      margin: 40PX 360PX;

      .itd-li {
        margin-bottom: 60PX;

        .itd-title-box {
          display: flex;
          align-items: center;

          .itd-t {
            margin-left: 10PX;

            .itd-t-t1 {
              font-size: 14PX;
              color: #274a52;
            }

            .itd-t-t2 {
              font-size: 18PX;
              font-weight: bold;
            }
          }
        }

        .itd-c-box {
          margin-top: 20PX;

          .itd-c {
            line-height: 26PX;
            font-size: 16PX;
            text-indent: 2em;
          }

          .c-bold {
            font-weight: bold;
          }

          .mlt25 {
            margin-top: 25PX;
          }

          .itd-c-box-d {
            display: flex;
            align-items: flex-start;
          }

          .itd-sign {
            margin-left: 25PX;
            height: 200PX;

            img {
              border-radius: 10PX;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .footer {
    height: 86PX;
    background: #003265;

    .footer-box {
      margin: 0 360PX;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .footer-li {
        display: flex;

        .fl-text {
          color: #fff;
          font-size: 14PX;
          margin-right: 10PX;
        }

        .fl-nationl {
          color: #878787;
          font-weight: bolder;
          margin-left: 5PX;
        }

        .fl-p-img {
          width: 16PX;
          height: 18PX;
        }

        .fl-phone {
          font-size: 18PX;
          color: #61ADBE;
          margin-left: 5PX;
        }
      }
    }
  }
}
</style>